import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/configuraciones-de-polizas-de-carga-externa/';

/**
 * GET Configuraciones De Polizas De Carga Externa
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConfiguracionesDePolizasDeCargaExterna = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Configuracion De Poliza De Carga Externa
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getConfiguracionDePolizaCargaExterna = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Configuracion De Poliza De Carga Externa
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionDePolizaCargaExterna = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion De Poliza De Carga Externa
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionDePolizaCargaExterna = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configuracion De Poliza De Carga Externa
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguracionDePolizaCargaExterna = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Configuracion De Poliza De Carga Externa
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarConfiguracionDePolizaCargaExterna = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
